import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { PhotoSwipeGallery } from 'react-photoswipe'
let options = {
    //http://photoswipe.com/documentation/options.html
}
  
let getThumbnailContent = item => {
    return (
        <div
            className="gallery-item"
            itemProp="associatedMedia"
            itemScope=""
            itemType="http://schema.org/ImageObject"
        >
            <a data-size="750x1002" href={item.src} itemProp="contentUrl">
            <img
                alt="..."
                className="img-rounded img-responsive"
                itemProp="thumbnail"
                src={item.src}
            />
            </a>
            <figcaption className="gallery-caption" itemProp="caption description">
            {item.title}
            </figcaption>
      </div>
    )
}
const photoSwipeItems = [
    {
      src: require("assets/images/galeria/gal1.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal2.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal3.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal4.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal5.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal6.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal7.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal8.jpg"),
      title: "",
      w: "1024",
      h: "683"
    },
    {
      src: require("assets/images/galeria/gal9.jpg"),
      title: "",
      w: "1024",
      h: "576"
    },
    {
      src: require("assets/images/galeria/gal10.jpg"),
      title: "",
      w: "1280",
      h: "576"
    },
    {
      src: require("assets/images/header/banner1.jpg"),
      title: "",
      w: "1280",
      h: "853"
    },
    {
      src: require("assets/images/galeria/gal11.jpg"),
      title: "",
      w: "1280",
      h: "576"
    },
  ];
const Galeria = () => {
    return(
        <div className="section text-center" id="galeria">
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto text-center" md="8">
                        <h2 className="title">Galeria</h2>
                    </Col>
                </Row>
                
                    <PhotoSwipeGallery
                        items={photoSwipeItems}
                        options={options}
                        thumbnailContent={getThumbnailContent}
                    />
                
            </Container>
        </div>
    )
}
export default Galeria